module.exports = __webpack_public_path__ + "img/history.901703ac.svg";